import React, { useState } from 'react';
import { ShieldAlert } from 'lucide-react';
import { SosTriggerModal } from './SosTriggerModal';

export const SosFloatingButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Floating Emergency Button */}
      <div className="fixed bottom-24 md:bottom-8 right-5 z-[999] flex flex-col items-end">
        <button
          onClick={() => setIsOpen(true)}
          className="group relative flex items-center gap-2 px-4 py-3.5 rounded-full bg-gradient-to-r from-red-600 to-rose-600 hover:from-red-700 hover:to-rose-700 text-white font-black text-sm shadow-xl shadow-red-600/40 hover:shadow-2xl hover:scale-105 transition-all duration-200 border-2 border-white/60"
          aria-label="Emergency SOS Alert"
        >
          {/* Pulsing ring animation */}
          <span className="absolute -inset-1 rounded-full bg-red-500 opacity-40 animate-ping pointer-events-none"></span>
          
          <div className="relative flex items-center justify-center">
            <ShieldAlert className="w-5 h-5 text-white animate-pulse" />
          </div>

          <div className="flex flex-col text-left leading-none">
            <span className="text-[9px] uppercase font-black tracking-wider text-yellow-300">
              Emergency
            </span>
            <span className="text-sm font-extrabold tracking-tight">
              SOS Alert
            </span>
          </div>
        </button>
      </div>

      {/* Trigger Modal */}
      <SosTriggerModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};
